import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { AiOutlineRightCircle } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router";
import OutlinedButton from "../../components/Common/Buttons/OutlinedButton";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import NavBarTitles from "../../components/Common/TabBar";
import "./webBooking.scss";
import WebBookingHomeHealthCare from "./WebBookingHomeHealthCare";
import WebBookingInClinicConsultation from "./WebBookingInClinicConsultation";
import WebBookingOnlineConsultation from "./WebBookingOnlineConsultation";

const WebBookings = () => {
  const pathName = useLocation();
  const navigate = useNavigate();
  const [serviceList, setServiceList] = useState([]);
  const viewService = {
    postfix: true,
    className: "managehealth viewBtn",
    icon: <AiOutlineRightCircle color="#4E91C2" />,
    onClick: () =>
      navigate(
        `/web-bookings/${pathName.pathname.split("/")[2]}/view-services`,
      ),
    style: { width: "240px" },
    label: "View Service",
  };
  const location = useLocation();
  useEffect(() => {
    list_api_call();
  }, []);

  const list_api_call = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}services/list`)
      .then((response) => {
        setServiceList(response?.data);
      });
  };

  const servicesBreadcrumbs = useMemo(() => {
    return serviceList
      ?.filter((data) => data?.slug_url === pathName.pathname.split("/")[2])
      .map((val) => val);
  }, [serviceList, pathName.pathname]);

  const renderComponent = () => {
    switch (location.pathname) {
      case "/web-bookings/home-healthcare-bookings":
        return <WebBookingHomeHealthCare />;
      case "/web-bookings/online-consultations":
        return <WebBookingOnlineConsultation />;
      case "/web-bookings/in-clinic-appointments":
        return <WebBookingInClinicConsultation />;
      default:
        return <></>;
    }
  };

  const breadcrumbsList = [
    {
      text: `Web Bookings, Consultations & Appointments`,
      link: `/web-bookings/home-healthcare-bookings`,
    },
    { text: servicesBreadcrumbs ? servicesBreadcrumbs[0]?.name : "", link: "" },
  ];

  const ServiceTab = serviceList.map((item) => ({
    name: item.name,
    navigatePath: `/web-bookings/${item.slug_url}`,
  }));
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <AntdBreadcrumbs
          className="healthsyMasterBreadCrumbs pb-2"
          breadcrumbsList={breadcrumbsList}
        />
        <OutlinedButton props={viewService} />
      </div>
      <NavBarTitles titles={ServiceTab} />
      <div>{renderComponent()}</div>
    </>
  );
};

export default WebBookings;
